import React, { Component } from "react";
import Clients from "../clients/Clients";
import { Layout, Card } from "antd";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PrivateNavBarClients from "../nav-bar/PrivateNavBarClients";
// import BigFooter from '../footer/BigFooter'
import "./client-selector.css";
import PrivateFooter from "../footer/PrivateFooter";
import { getCustomsClients } from "../../utils";

const { Content } = Layout;

export class ClientSelector extends Component {

  componentDidMount() {
    const { user, history } = this.props;
    if (!user) {
      history.push("/login");
    } else {
      const customClients = getCustomsClients()
      const hasMatchingClient = user.workClients.some(clientId =>
        customClients.map(r => r._id).flat().includes(clientId)
      );
      if (hasMatchingClient) {
        history.push("/custom-client-selector");
      }
    }
  }

  render() {
    const { intl } = this.props;
    return (
      <Layout>
        <PrivateNavBarClients />
        <Content
          className="pri-site-background-color-white"
          style={{ padding: "2em 0" }}
        >
          <Card
            title={intl.formatMessage({ id: "clients_selector_title" })}
            style={{ margin: "0 20px" }}
          >
            <Clients />
          </Card>
        </Content>
        {/* <BigFooter /> */}
        <PrivateFooter />
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientSelector))
);
